/**
 * Props for instructors slot (subset of Course API type)
 *
 * @remarks
 *
 * @see `browse/types/course`
 */

/**
 * Converts Course API fields to `CourseCard` instructors props.
 *
 * @remarks
 *
 * @see `browse/types/course`
 */
export const instructorsPropsFrom = _ref => {
  var _course$visible_instr;

  let {
    course
  } = _ref;
  return {
    displayNames: ((_course$visible_instr = course.visible_instructors) !== null && _course$visible_instr !== void 0 ? _course$visible_instr : []).map(_ref2 => {
      let {
        display_name: displayName
      } = _ref2;
      return displayName;
    })
  };
};
//# sourceMappingURL=instructors.js.map